import React from 'react';
import { Box, Container, Typography, Button, Link } from '@mui/material';
import ClassificationBannerHeader from '../../common/banner/classifactionBannerHeader';
import PageHeader from '../../common/banner/pageHeader';
import { useNavigate } from 'react-router-dom';
import EmassDashboard from '../../common/buttons/emassDash';

export default function PMOverview() {

  const baseRoute = process.env.REACT_APP_BASE_RpmOUTE || '/';
  const imgRoute = 'images/analytics/pm-overview-1.png';
  const imgRoute2 = 'images/analytics/pm-overview-2.png';
  const route = baseRoute + imgRoute;
  const route2 = baseRoute + imgRoute2;
  const navigate = useNavigate();
  const handleResponse = (() => {
    navigate('/pmDetails')
  });
  
  return (
    <Container sx={{ minWidth:1800, mt: 10, mb: 10 }}>
      <Box sx={{pt: 2}}>
        <ClassificationBannerHeader></ClassificationBannerHeader>
        <PageHeader title="CCG Dashboards"></PageHeader>
      </Box>
      <Typography variant='h4' 
        sx ={{display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center', 
              fontSize: '1.35em', 
              marginBottom: '10px'}}>
        PM Overview
      </Typography>
      <EmassDashboard></EmassDashboard>
      <Box
        sx={{          
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column'
        }}
      >
      <img 
          alt="PM Info"
          src={route}
          width="100%"
          height="100%"
          style={{ border: 'none', display: 'flex', objectFit: 'none', marginTop: '-10px', marginBottom: '-46px' }}
      />
      <img 
          alt="PM Info 2"
          src={route2}
          width="100%"
          height="100%"
          style={{ border: 'none', display: 'flex', objectFit: 'none', marginTop: '0px', marginBottom: '-70px', marginRight: '3px' }}
      />
      </Box>
    </Container>
  );
};